function onClickOutside (element, callback) {
  document.addEventListener('click', event => {
    if (!element.contains(event.target)) {
      callback();
    }
  });
}

function initArticleSummary (parentElement) {
  const summaryElement = parentElement.querySelector('.js-article-summary');

  if (!summaryElement) {
    return;
  }

  const infoElement = summaryElement.querySelector('.article-summary__information');
  const infoButtonElement = summaryElement.querySelector('.js-article-summary__information-button');
  const tooltipCloseElement = summaryElement.querySelector('.js-article-summary__tooltip-close');

  const showTooltip = () => infoElement.classList.add('active');
  const hideTooltip = () => infoElement.classList.remove('active');

  infoButtonElement.addEventListener('click', showTooltip);
  tooltipCloseElement.addEventListener('click', hideTooltip);

  onClickOutside(infoElement, hideTooltip);
}

export {initArticleSummary};
